"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var sis_list_paging_component_1 = require("./sis-list-paging.component");
require("./sis-list-sorting.component.css");
var ListSorting = /** @class */ (function () {
    function ListSorting() {
        this._sortField = null;
        this._sortAscending = false;
    }
    Object.defineProperty(ListSorting.prototype, "items", {
        get: function () {
            return this._items;
        },
        set: function (items) {
            this._items = items.slice(0); //clone
            this._sortItems();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListSorting.prototype, "sortFunction", {
        set: function (sortFunction) {
            this._sortFunction = sortFunction;
            this._sortItems();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListSorting.prototype, "sortField", {
        get: function () {
            return this._sortField;
        },
        set: function (sortField) {
            this._sortField = sortField;
            this._sortItems();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListSorting.prototype, "isAscending", {
        get: function () {
            return this._sortAscending;
        },
        set: function (sortAscending) {
            this._sortAscending = sortAscending;
            this._sortItems();
        },
        enumerable: true,
        configurable: true
    });
    ListSorting.prototype.ngOnChanges = function (changes) {
        changes['items'] && (this.items = changes['items'].currentValue);
    };
    Object.defineProperty(ListSorting.prototype, "sortedItems", {
        get: function () {
            return this._items;
        },
        enumerable: true,
        configurable: true
    });
    ListSorting.prototype.changeSorting = function (sortField, isAscending) {
        this._sortAscending = isAscending;
        this._sortField = sortField;
        this._sortItems();
        this.listPagingElements.forEach(function (listPaging) {
            listPaging.page = 0;
        });
    };
    ListSorting.prototype._sortItems = function () {
        var _this = this;
        if (this._sortField && this._sortFunction) {
            if (this._sortAscending) {
                this._items.sort(function (item1, item2) { return _this._sortFunction(_this._sortField, _this._sortAscending, item1, item2); });
            }
            else {
                this._items.sort(function (item1, item2) { return -1 * _this._sortFunction(_this._sortField, _this._sortAscending, item1, item2); });
            }
        }
    };
    __decorate([
        core_1.ContentChildren(sis_list_paging_component_1.ListPaging),
        __metadata("design:type", core_1.QueryList)
    ], ListSorting.prototype, "listPagingElements", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], ListSorting.prototype, "items", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], ListSorting.prototype, "sortFunction", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ListSorting.prototype, "sortField", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], ListSorting.prototype, "isAscending", null);
    ListSorting = __decorate([
        core_1.Component({
            
            selector: 'sis-list-sorting',
            template: require('./sis-list-sorting.component.html')
        })
    ], ListSorting);
    return ListSorting;
}());
exports.ListSorting = ListSorting;
//# sourceMappingURL=sis-list-sorting.component.js.map